// This is used for sending the module type along with sub module type to the image process to find the corresponding prefix to add in API
const ModuleTypeEnum = {
  Settings: 'Settings',
  WatchLive: 'Watch live',
  EventPage: 'EventPage',
  Program: 'Program',
  Information: 'Information',
  Dialogue: 'Dialogue',
  Participant: 'Participant',
  Invite: 'Invite',
};

export default Object.freeze(ModuleTypeEnum);
